<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
           <el-form-item label="选择区间:" prop="costBelong1">
                <el-date-picker
                  v-model="searchFrom.costBelong1"
                  type="monthrange"
                  value-format="yyyy-MM"
                  range-separator="至"
                  start-placeholder="开始月份" :picker-options="pickerOptions"
                  end-placeholder="结束月份">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="流向:" prop="shipFlowId">
                <el-select  v-model="searchFrom.shipFlowId"   placeholder="请选择">
                  <el-option  label="全部" value="" ></el-option>
                  <el-option v-for="item in LXList" :label="item.showName" :value="item.id" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="隶属公司:" class="jiage" prop="belongCompany">
              <el-select  v-model="searchFrom.belongCompany"    placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="中物唐山曹妃甸区物流有限责任公司" value="中物唐山曹妃甸区物流有限责任公司" ></el-option>
                <el-option  label="中物(北京)物流信息服务有限公司唐山曹妃甸分公司" value="中物(北京)物流信息服务有限公司唐山曹妃甸分公司" ></el-option>
                <el-option  label="金刚鲸(天津)供应链管理有限公司" value="金刚鲸(天津)供应链管理有限公司" ></el-option>
                <el-option  label="第三方公司" value="第三方公司" ></el-option>
              </el-select>
            </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item v-if="btnFlg[1]">
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border v-if="tableList.length>0">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="shipFlowName"  min-width="120" :formatter="emptyFn" label="流向"></el-table-column>
        <el-table-column prop="belongCompany"  min-width="300" :formatter="emptyFn"  :show-overflow-tooltip="true" label="隶属公司"></el-table-column>
        <el-table-column :label="tableList[0].lastDate">
          <el-table-column prop="lastAllWeight" width="160" :formatter="emptyFn" label="实际载重(吨)"></el-table-column>
          <el-table-column prop="lastFreightPrice" width="160" :formatter="emptyFn" label="运费金额(元)"></el-table-column>
          <el-table-column prop="lastDemurragePrice" width="160" :formatter="emptyFn" label="滞期费(元)"></el-table-column>
          <el-table-column prop="lastPaymentPrice" width="160" :formatter="emptyFn" label="实付运费总额(元)"></el-table-column>
         </el-table-column>
        <el-table-column :label="tableList[0].date">
          <el-table-column prop="allWeight" width="160" :formatter="emptyFn" label="实际载重(吨)"></el-table-column>
          <el-table-column prop="freightPrice" width="160" :formatter="emptyFn" label="运费金额(元)"></el-table-column>
          <el-table-column prop="demurragePrice" width="160" :formatter="emptyFn" label="滞期费(元)"></el-table-column>
          <el-table-column prop="paymentPrice" width="160" :formatter="emptyFn" label="实付运费总额(元)"></el-table-column>
         </el-table-column>

      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <!-- <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination> -->
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { monthCompare, sShipDictionaryList } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        type: 2
      },
      total: 0,
      loading: 'false',
      isDisable: false,
      LXList: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      btnFlg: [],
      btnIdArr: ['00KM0C0100', '00KM0C0200', '00KM0C0300', '00KM0C0400', '00KM0C0500',
        '00KM0C0600', '00KM0C0700', '00KM0C0800', '00KM0C0900']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/SshipSettlement')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
    sShipDictionaryList({ groupNo: 'ship_flow' }).then(res => {
      this.LXList = res
    })
    this.$set(this.searchFrom, 'costBelong1', [this.getPreMonth(), this.getPreMonth()])
    this.getList(this.searchFrom)
  },
  methods: {
    /** 获取上一个月 */
    getPreMonth () {
      var arr = getNowMonth().split('-')
      var year = arr[0] // 获取当前日期的年份
      var month = arr[1] // 获取当前日期的月份

      var year2 = year
      var month2 = parseInt(month) - 1
      if (month2 == 0) {
        // 1月的上一月是前一年的12月
        year2 = parseInt(year2) - 1
        month2 = 12
      }
      if (month2 < 10) {
        // 10月之前都需要补0
        month2 = '0' + month2
      }
      var preMonth = year2 + '-' + month2
      return preMonth
      function getNowMonth () {
        var date = new Date()
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        month = month > 9 ? month : '0' + month
        var nowMonth = year + '-' + month
        return nowMonth
      }
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.shipping + '/sShipSettlement/exportSettlementList',
        form,
        '海运结算'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 判断时间是否大于1年
    estimateRegistrationTime (startDate, endDate) {
      var begin = new Date(startDate).getTime()
      var end = new Date(endDate).getTime()
      if (parseInt(Math.abs(begin - end) / 1000 / 60 / 60 / 24) > 365) {
        return true
      } else {
        return false
      }
    },
    // 获取列表
    getList (searchFrom) {
      if (!this.searchFrom.costBelong1) {
        this.$alert('请选择时间区间', '系统提示')
        return
      }
      let arr = this.searchFrom.costBelong1
      if (this.estimateRegistrationTime(arr[0] + '-01', arr[1] + '-30')) {
        this.$alert('选择的时间区间不能大于一年', '系统提示')
        return
      }
      this.$set(this.searchFrom, 'costBelong', [arr[0] + '-01', arr[1] + '-01'])
      this.loading = true
      monthCompare(searchFrom).then(res => {
        this.loading = false
        this.tableList = [res]
        this.total = res.total
        this.tongji = res.map
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        type: 2,
        createTime: null
      }
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
</style>
